import { useMemo, useState } from "react";
import { Group } from "@mantine/core";
import { useModelsStore } from "../../stores/ConfigStore";
import { useLanguage } from "../../stores/LanguageStore";
import Selector from "./Selector";
import { getMEmails, getSMV } from "../../api/ModelsApi";

function getOptionName(option) {
  return `${option.name} #${option.id}`;
}

// value = model_profile

const ModelSmvSelector = ({
  id,
  label,
  placeholder,
  size,
  required,
  value,
  onChange,
  leftSection,
  disabled,
  className,
  ...other
}) => {
  const lang = useLanguage((s) => s.language);
  const models = useModelsStore((s) => s.model_smv);
  const [loading, setLoading] = useState(false);
  const handleLoad = () => {
    setLoading(true);
    getSMV().finally(() => setLoading(false));
  };

  const options = useMemo(() => {
    let result = [{ label: lang.global.no_folder, options: [] }];
    models?.forEach((item) => {
      let place = result.find((x) => x.label === item?.folder?.name);
      if (place) {
        place.options.push({
          ...item,
          option_name: getOptionName(item),
        });
      } else {
        if (item?.folder) {
          result.push({
            label: item?.folder?.name,
            options: [
              {
                ...item,
                option_name: getOptionName(item),
              },
            ],
          });
        } else {
          result[0].options.push({
            ...item,
            option_name: getOptionName(item),
          });
        }
      }
    });
    return models?.length > 0
      ? result.sort((a, b) => a.label === lang.global.no_folder)
      : [];
  }, [lang.global.no_folder, models]);

  return (
    <Group wrap="nowrap" w={"100%"} gap={"xs"}>
      <Selector
        disabled={disabled}
        id={id}
        label={label}
        leftSection={leftSection}
        loading={loading}
        onChange={(val) => onChange(val)}
        onDropdownOpen={handleLoad}
        options={options}
        placeholder={
          placeholder ||
          lang.campaign.selectors.email.placeholder + (required ? " *" : "")
        }
        required={required}
        size={size}
        value={value}
        getOptionName={getOptionName}
        hasGroup
        getError={false}
        autoFocus={false}
        className={className}
        other={other}
        width={300}
      />
    </Group>
  );
};

export default ModelSmvSelector;
